<div class="product-wrapper" [routerLink]="['/shop/product/', product.title.replace(' ', '-')]" >
    <div class="product-image" [style.background-image]="'url(' + (product.images[0]?.src ) + ')'" >
        </div>
        <h5 class="text-center">{{product?.title | titlecase }}</h5>
        <h6 class="text-center">{{ product?.price * currency?.price | discount:product | currency:currency?.currency:'R' }}</h6>
        <div class="cta text-center" [routerLink]="['/shop/product/', product.title.replace(' ', '-')]">
            BUY NOW
        </div>
</div>